export default [
    {
        path: '/automations',
        name: 'Automations',
        meta: {
            requiresAuth: true,
            title: 'Automations',
        },
        components: {
            default: () => import('@views/customerAutomations/CustomerAutomationsIndex.vue'),
            agent: () => import('@views/customerAutomations/CustomerAutomationsIndex.vue'),
        },
    },
    {
        path: '/automations/create',
        name: 'AutomationsCreate',
        props: {
            default: () => ({ isCreate: true }),
            agent: () => ({ isCreate: true }),
        },
        meta: {
            requiresAuth: true,
            title: 'Create automation sequence',
        },
        components: {
            default: () => import('@views/customerAutomations/CustomerAutomationsCreate.vue'),
            agent: () => import('@views/customerAutomations/CustomerAutomationsCreate.vue'),
        },
    },
    {
        path: '/automations/:id/edit',
        name: 'AutomationsEdit',
        props: {
            default: (route) => ({ id: route.params.id, isCreate: false }),
            agent: (route) => ({ id: route.params.id, isCreate: false }),
        },
        meta: {
            requiresAuth: true,
            title: 'Edit customer automation',
        },
        components: {
            default: () => import('@views/customerAutomations/CustomerAutomationsEdit.vue'),
            agent: () => import('@views/customerAutomations/CustomerAutomationsEdit.vue'),
        },
    },
];
